export enum PlatformEventScopes {
    Company = 'company',
}
